import { useEffect, useState } from "react"
import DeleteButton from "../ui/components/DeleteButton"
import EditButton from "../ui/components/EditButton"
import DinamicBoxButton from "../ui/components/DinamicBoxButton"
import axios from "axios"
import { BACKEND } from "../../config/configEnvs"
import { FaSave, FaTimes } from "react-icons/fa"
import { toast } from "react-toastify"
import TiposProducto from "../../utils/plainValues/TiposProducto"
import TiposCosto from "../../utils/plainValues/TiposCosto"

const ItemRowProductStakeholder = ({ product, index, deleteProduct, fetcher, categories = [] }) => {

  const [editModeEnabled, setEditModeEnabled] = useState(false)
  const [productToUpdate, setProductToUpdate] = useState(product)
  const [categoryId, setCategoryId] = useState(product?.category?.id || product?.category || "")
  const [subcategoryId, setSubcategoryId] = useState(product?.subcategory?.id || product?.subcategory || "")
  const [subcategories, setSubcategories] = useState([])

  // Sync with parent updates when not editing, so the row reflects latest saved values
  useEffect(() => {
    if (!editModeEnabled) {
      setProductToUpdate(product)
      setCategoryId(product?.category?.id || product?.category || "")
      setSubcategoryId(product?.subcategory?.id || product?.subcategory || "")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, editModeEnabled])

  const loadSubcategories = async (catId) => {
    try {
      if (!catId) {
        setSubcategories([])
        return
      }
      const url = `${BACKEND}/api/stakeholderProductsSubcategories?limit=0&where[category][equals]=${catId}`
      const { data } = await axios.get(url)
      setSubcategories(data?.docs || [])
    } catch (e) {
      console.log(e)
      toast.error("Error al cargar subcategorías")
    }
  }

  useEffect(() => {
    if (editModeEnabled) {
      loadSubcategories(categoryId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editModeEnabled])

  useEffect(() => {
    if (!editModeEnabled) return
    loadSubcategories(categoryId)
    setProductToUpdate((p) => ({ ...p, category: categoryId }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId])

  const updateProduct = async () => {
    try {
      const response = await axios.put(`${BACKEND}/api/stakeholdersProducts/${product.id}`, {
        name: productToUpdate.name,
        description: productToUpdate.description,
        price: productToUpdate.price,
        stakeholder: productToUpdate.stakeholder?.id,
        currency: productToUpdate.currency,
        category: categoryId || null,
        subcategory: subcategoryId || null,
        type: productToUpdate.type || null,
        costType: productToUpdate.costType || null,
      })
      const updated = response?.data?.doc || {}
      setProductToUpdate(updated)
      const stakeholderId = updated?.stakeholder?.id || productToUpdate?.stakeholder?.id || product?.stakeholder?.id || product?.stakeholder
      if (typeof fetcher === 'function') {
        try { await fetcher(stakeholderId) } catch (_) {}
      }
      setEditModeEnabled(false)
      // toast.success("Producto actualizado correctamente")
    } catch (e) {
      console.log(e)
      toast.error("Error al actualizar el producto")
    }
  }

  const handleEdit = () => {
    setProductToUpdate(product) // Reset to original values when starting edit
    setCategoryId(product?.category?.id || product?.category || "")
    setSubcategoryId(product?.subcategory?.id || product?.subcategory || "")
    setEditModeEnabled(true)
  }

  const handleCancel = () => {
    setProductToUpdate(product) // Reset to original values
    setCategoryId(product?.category?.id || product?.category || "")
    setSubcategoryId(product?.subcategory?.id || product?.subcategory || "")
    setEditModeEnabled(false)
  }
  
  return (
    <tr key={product.id || index} className="hover:bg-gray-50 z-10">
      
      {/* Nombre */}
      <td className="px-4 py-3 whitespace-nowrap w-[10%] text-xs text-gray-900">
        {editModeEnabled ? (
          <input 
            type="text" 
            value={productToUpdate.name || ""} 
            onChange={(e) => setProductToUpdate({...productToUpdate, name: e.target.value})}
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        ) : (
          <input 
            type="text" 
            value={productToUpdate.name || ""}
            disabled
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        )}
      </td>

      {/* Descripción */}
      <td className="px-4 py-3 whitespace-nowrap w-[15%] text-xs text-gray-900">
        {editModeEnabled ? (
          <input 
            type="text" 
            value={productToUpdate.description || ""} 
            onChange={(e) => setProductToUpdate({...productToUpdate, description: e.target.value})}
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        ) : (
          <input 
            type="text" 
            value={productToUpdate.description || ""}
            disabled
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        )}
      </td>

      {/* Tipo */}
      <td className="px-4 py-3 whitespace-nowrap w-[15%] text-xs text-gray-900">
        {editModeEnabled ? (
          <select 
            value={productToUpdate.type || ""}
            onChange={(e) => setProductToUpdate({...productToUpdate, type: e.target.value})}
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          >
            {TiposProducto.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        ) : (
          <input 
            type="text" 
            value={productToUpdate?.type || "-"}
            disabled
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        )}
      </td>

      {/* Categoría */}
      <td className="px-4 py-3 whitespace-nowrap w-[15%] text-xs text-gray-900">
        {editModeEnabled ? (
          <select 
            value={categoryId || ""}
            onChange={(e) => { setCategoryId(e.target.value); setSubcategoryId("") }}
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          >
            <option value="">Sin categoría</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>{c.categoryName}</option>
            ))}
          </select>
        ) : (
          <input 
            type="text" 
            value={
              categories.find((c) => c.id === (productToUpdate?.category?.id || productToUpdate?.category))?.categoryName 
              || product?.category?.categoryName 
              || "-"
            }
            disabled
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        )}
      </td>

      {/* Subcategoría */}
      <td className="px-4 py-3 whitespace-nowrap w-[15%] text-xs text-gray-900">
        {editModeEnabled ? (
          <select 
            value={subcategoryId || ""}
            onChange={(e) => setSubcategoryId(e.target.value)}
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          >
            <option value="">Sin subcategoría</option>
            {subcategories.map((s) => (
              <option key={s.id} value={s.id}>{s.subcategoryName}</option>
            ))}
          </select>
        ) : (
          <input 
            type="text" 
            value={
              subcategories.find((s) => s.id === (productToUpdate?.subcategory?.id || productToUpdate?.subcategory))?.subcategoryName 
              || product?.subcategory?.subcategoryName 
              || "-"
            }
            disabled
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        )}
      </td>

      {/* Moneda */}
      <td className="px-4 py-3 whitespace-nowrap w-[10%] text-xs text-gray-900">
        {editModeEnabled ? (
          <select 
            value={productToUpdate.currency || ""} 
            onChange={(e) => setProductToUpdate({...productToUpdate, currency: e.target.value})}
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          >
            <option value="Soles">Soles</option>
            <option value="Dolares">Dolares</option>
          </select>
        ) : (
          <input 
            type="text" 
            value={product?.currency || "-"}
            disabled
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        )}
      </td>

      {/* Precio */}
      <td className="px-4 py-3 whitespace-nowrap w-[5%] text-xs text-gray-900">
        {editModeEnabled ? (
          <input 
            type="number" 
            value={productToUpdate.price || ""} 
            onChange={(e) => setProductToUpdate({...productToUpdate, price: parseFloat(e.target.value) || 0})}
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
            step="0.01"
            min="0"
          />
        ) : (
          <input 
            type="number" 
            value={productToUpdate.price || ""}
            disabled
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
            step="0.01"
            min="0"
          />
        )}
      </td>

      {/* Tipo de costo */}
      <td className="px-4 py-3 whitespace-nowrap w-[10%] text-xs text-gray-900">
        {editModeEnabled ? (
          <select 
            value={productToUpdate.costType || ""} 
            onChange={(e) => setProductToUpdate({...productToUpdate, costType: e.target.value})}
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          >
            {TiposCosto.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        ) : (
          <input 
            type="text" 
            value={productToUpdate.costType || ""}
            disabled
            className="w-full px-0 py-0 border-none bg-transparent rounded text-xs"
          />
        )}
      </td>

      {/* Acciones */}
      <td className="px-4 py-3 w-[5%] text-center text-xs">
        
        <div className="flex w-full justify-start flex-row gap-2">
          {/* <DeleteButton
            content="Eliminar producto"
            action={() => deleteProduct(product.id)}
          /> */}

          {editModeEnabled && (
            <DinamicBoxButton
              content="Guardar"
              icon={<FaSave className="text-xs"/>}
              color="blue"
              action={updateProduct}
            />
          )}

          {editModeEnabled && (
            <DinamicBoxButton
              content="Cancelar"
              icon={<FaTimes />}
              color="red"
              action={handleCancel}
           />
          )}

          {!editModeEnabled && (
            <EditButton
              content="Editar producto"
              action={handleEdit}
            />
          )}
        </div>
      </td>
    </tr>
  )
}

export default ItemRowProductStakeholder;